<template>
    <div>
        <Loading/>
        <MenuInterno/>
        <span><strong>- MEDIÇÕES <i class="fas fa-chevron-right"></i> LISTAGEM
      <span v-if="paginaTop != ''"><i class="fas fa-chevron-right"></i> {{paginaTop}}</span>
      </strong></span>

        <div v-if="listagem == 'listagem'">
            <div class="text-right mb-2">
                <button class="btn btn-sm btn-success" @click="viewAdicionar">Adicionar Medição</button>
            </div>
            <table id="tabela" class="table table-striped table-responsive-sm">
                <thead>
                <tr>
                    <th>Id</th>
                    <th>Referência</th>
                    <th>Detalhe dos Serviços</th>
                    <th>Ações</th>
                </tr>
                </thead>
            </table>
            <!-- <div style="height:700px">
              <div id="grid-medicoes" style="width:100%; height:100%; background-color:white;"></div>
            </div> -->
        </div>

        <div v-else-if="listagem == 'cadastrar'">
            <MedicoesCadastro/>
        </div>

        <div v-else-if="listagem == 'editar'">
            <MedicoesEditar :id="id"/>
        </div>

    </div>
</template>

<script>
    import MenuInterno from '../menu-interno/MenuInterno.vue'
    import MedicoesCadastro from '../medicoes/MedicoesCadastro.vue'
    import MedicoesEditar from '../medicoes/MedicoesEditar.vue'
    import Loading from '../login/Loading'

    var gridMedicoes;

    export default {
        name: 'MedicoesListagem',
        components: {
            Loading,
            MenuInterno,
            MedicoesCadastro,
            MedicoesEditar
        },
        data() {
            return {
                listagem: 'listagem',
                paginaTop: ''
            }
        },
        methods: {
            viewAdicionar() {
                this.listagem = 'cadastrar',
                    this.paginaTop = 'ADICIONAR MEDIÇÃO',
                    $('#tabela').parents('div.dataTables_wrapper').first().hide();
            }
        },
        mounted: function () {

            let thiss = this;
            let swall = this.$swal;

            let tabela = $('#tabela').DataTable({
                "oLanguage": {
                    "sSearch": "Pesquisar:",
                    "sEmptyTable": "Nenhum dado para exibição",
                    "sZeroRecords": "Nenhum dado encontrado",
                    "oPaginate": {
                        "sNext": "Próximo",
                        "sPrevious": "Anterior",
                    },
                    "sLengthMenu": "Mostrar _MENU_ dados",
                    "sInfoFiltered": " - (filtrado de _MAX_ dados)",
                    "sInfo": "Mostrando _START_ até _END_ de _TOTAL_ dados",
                },
                "ajax": {
                    "url": axios.defaults.baseURL+"/api/sist-obras/medicoes",
                    dataSrc: '',
                    headers: {
                        'Authorization': `Bearer ${Store.getters.pegaAccessToken}`
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        API.geraNovoTokenDatatable(jqXHR, tabela);
                    }
                },
                "columns": [
                    {"data": "o03_id", visible: false},
                    {
                        targets: [1],
                        mData: function (data) {
                            if(data.o03_refer == null)
                                return '';

                            var d = new Date(data.o03_refer);
                            return d.getDate()+'/'+d.getMonth()+'/'+d.getFullYear();
                        }
                    },
                    {"data": "o03_descr_serv"},
                    {
                        targets: [3],
                        width: '10%',
                        orderable: false,
                        mData: data => criarBotoes(data.o03_id)
                    }
                ],
                'fnDrawCallback': function () {

                    $('.editar').on('click', function () {
                        var dados = $(this).data('id');
                        thiss.id = dados;
                        thiss.listagem = 'editar'
                        thiss.paginaTop = 'EDITAR'
                        $('#tabela').parents('div.dataTables_wrapper').first().hide();
                    })
                    $('.excluir').on('click', function () {
                        var dados = $(this).data('id');
                        thiss.id = dados;

                        swall({
                            title: "Atenção!",
                            text: "Deseja realmente excluir a Medição selecionada?",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonText: 'Sim',
                            cancelButtonText: "Não!"
                        })
                            .then(
                                function () {
                                    API.enviarRequisicao('delete', '/api/sist-obras/medicoes/' + thiss.id)
                                        .then( resp => {
                                            swall('Atenção', 'A Medição foi deletada com sucesso', 'success')
                                                .then(
                                                    function () {
                                                        history.go(0);
                                                    }
                                                )
                                        })
                                },
                                function () {
                                    return false;
                                });

                    })

                }
            });


            function criarBotoes(id, ctrl) {
                if (ctrl != null) {
                    return '<a href="#" class="btnEditar' + ctrl + ' btn btn_editar_rh btn-default btn-sm">' +
                        '<i class="fa fa-edit" data-toggle="tooltip" title="Editar"></i>' +
                        '</a>' +
                        '<a href="#" data-id="' + id + '" class="btn btn-sm btn-info' + ctrl + ' btn btn-default btn-sm">' +
                        '<i class="fa fa-trash" data-toggle="tooltip" title="Deletar"></i>' +
                        '</a>';
                } else {
                    return "<button class='btn btn-sm editar' data-id='" + id + "'><i class='fa fa-edit text-info' ></i></button>" +
                        "<button class='btn btn-sm excluir' data-id='" + id + "'><i class='fa fa-trash text-danger'></i></button>";
                }
            }

            // axios
            //   .get('http://192.168.1.17:8085/api/sist-obras/medicoes/dhtmlx')
            //   .then(response => {
            //     this.dados = response.data
            //     gridMedicoes.parse(this.dados, "json");

            //     let thiss = this;
            //     let swall = this.$swal;

            //     $('.hdrcell').css('text-align', 'center');
            //     $('.hdrcell filter').css('margin-bottom', '10px');

            //     $('.editar').on('click', function(){
            //       var dados = $(this).data('id');
            //       thiss.id = dados;
            //       thiss.listagem = 'editar';
            //       thiss.paginaTop = 'EDITAR';
            //     })

            //     $('.excluir').on('click', function(){
            //       var dados = $(this).data('id');
            //       thiss.id = dados;

            //       swall({
            //         title: "Atenção!",
            //         text: "Deseja realmente excluir a Medição selecionada?",
            //         type: "warning",
            //         showCancelButton: true,
            //         confirmButtonText: 'Sim',
            //         cancelButtonText: "Não!"
            //       })
            //       .then(
            //           function () {
            //             axios
            //             .delete("http://192.168.1.17:8085/api/sist-obras/medicoes/"+thiss.id)
            //             .then(
            //                swall('', 'A Medição foi deletada com sucesso', 'success')
            //                .then(
            //                   function () {
            //                     history.go(0);
            //                   }
            //                 )
            //             )
            //           },
            //           function () {
            //             return false;
            //           });

            //     })
            //   });

            // gridMedicoes = new dhtmlXGridObject('grid-medicoes');
            // gridMedicoes.setImagePath("libs/imgs/");
            // gridMedicoes.setHeader("Código, Referência, Detalhe dos Serviços, Ações");
            // gridMedicoes.setInitWidths("70,150,650,150");
            // gridMedicoes.setColAlign("left,left,left,center");
            // gridMedicoes.setColTypes("ro,ro,ro,ro");
            // gridMedicoes.setColSorting("int,int,str");
            // gridMedicoes.attachEvent("onRowCreated",function(id){
            //     this.cells(id,3).setValue("<button class='btn btn-sm editar' data-id='"+id+"'><i class='fa fa-edit text-info'></i></button><button class='btn btn-sm excluir' data-id='"+id+"'><i class='fa fa-trash text-danger'></i></button>");
            //     return true;
            // });
            // gridMedicoes.init();
            // gridMedicoes.attachHeader("&nbsp;,#text_filter,#text_filter,&nbsp;");
            // // gridMedicoes.enableSmartRendering(true,50);
            // gridMedicoes.setColumnHidden(0,true);

        }
    }
</script>

<style scoped>

    h2 {
        color: #5377C1;
    }

    a {
        background-color: #18A689;
        color: #fff;
        font-size: 12px;
        text-decoration: none;
    }

</style>
